export default "__VITE_ASSET__n0j_UvVm__"